import React from 'react'
import LanguageDropdown from '../layout/LanguageDropdown';
import footerLogo from '../../Assets/images/main-logo-light.svg';
import googlePlay from '../../Assets/images/google-store2.svg';
import appStore from '../../Assets/images/apple-store2.svg';
import { Link } from 'react-router-dom';
import { Routes } from '../../constants/RouteConstants';
import { LanguageConstants } from '../../constants/LanguageConstants';
import { getFromStorage } from '../../utils/Helper';
import { StorageConstant } from '../../constants/Constants';
import { useContactSupportModal } from '../../context/ContactSupportModalContext';


function Footer() {
  const { openContactSupport } = useContactSupportModal();
  const hasAccessToken = Boolean(getFromStorage({ key: StorageConstant?.ACCESS_TOKEN }));
  const trendingProductsRoute = hasAccessToken ? '/product' : Routes.Login;
  return (
    <>

      <footer className="landing-footer check">
        <div className="container">
          <div className="landing-footer__grid row gy-4">
            <div className="landing-footer__brand col-lg-3">
              <img src={footerLogo} alt="Quote N Buy" className="landing-footer__logo-img" width={180} height={44} />
            </div>
            <div className="col-lg-9 col-12">
              <div className="row gy-3">
                <div className="col-6 col-md-3">
                  <h3 className="landing-footer__col-title">{LanguageConstants?.LANDING_FOOTER_COMPANY}</h3>
                  <ul className="landing-footer__links">
                    <li>
                      {hasAccessToken ? (
                        <Link to="/cms/about-us">{LanguageConstants?.LANDING_NAV_ABOUT}</Link>
                      ) : (
                        <a href="#landing-about">{LanguageConstants?.LANDING_NAV_ABOUT}</a>
                      )}
                    </li>
                    <li>
                      <Link to={{ pathname: '/', hash: 'landing-reviews' }}>
                        {LanguageConstants?.LANDING_FOOTER_REVIEWS}
                      </Link>
                    </li>
                    <li>
                      <Link to={trendingProductsRoute}>{LanguageConstants?.FOOTER_TRENDING_PRODUCTS}</Link>
                    </li>
                    <li>
                      <Link to={Routes.Faq}>{LanguageConstants?.FAQS}</Link>
                    </li>
                  </ul>
                </div>
                <div className="col-6 col-md-3">
                  <h3 className="landing-footer__col-title">{LanguageConstants?.LANDING_FOOTER_FOLLOW}</h3>
                  <ul className="landing-footer__links">
                    <li>
                      <a href="https://www.instagram.com/quotenbuy_/" target="_blank" rel="noopener noreferrer">
                        Instagram
                      </a>
                    </li>
                    <li>
                      <a href="https://www.facebook.com/profile.php?id=61592265694819" target="_blank" rel="noopener noreferrer">
                        Facebook
                      </a>
                    </li>
                    <li>
                      <a href="https://www.tiktok.com/@quotenbuy?lang=en" target="_blank" rel="noopener noreferrer">
                        TikTok
                      </a>
                    </li>
                    <li>
                      <a href="https://x.com/QuoteNbuy" target="_blank" rel="noopener noreferrer">
                        X
                      </a>
                    </li>
                    <li>
                      <a href="https://www.youtube.com/@QuoteNbuy" target="_blank" rel="noopener noreferrer">
                        YouTube
                      </a>
                    </li>
                    <li>
                      <a href="https://www.linkedin.com/company/110748100/admin/page-posts/published/" target="_blank" rel="noopener noreferrer">
                        LinkedIn
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="col-6 col-md-3">
                  <h3 className="landing-footer__col-title">{LanguageConstants?.LANDING_FOOTER_GET_APP}</h3>
                  <div className="landing-footer__apps">
                    <a className="landing-footer__app-btn" href="https://play.google.com" target="_blank" rel="noopener noreferrer">
                      <img className='w-100' src={googlePlay} alt="Google Play" />
                    </a>
                    <a className="landing-footer__app-btn" href="https://apps.apple.com" target="_blank" rel="noopener noreferrer">
                      <img className='w-100' src={appStore} alt="App Store" />
                    </a>
                  </div>
                </div>
                <div className="landing-footer__contact-col col-6 col-md-3">
                  <button
                    type="button"
                    className="landing-footer__contact"
                    onClick={openContactSupport}
                  >
                    {LanguageConstants?.FOOTER_CONTACT_SUPPORT}
                    <i className="icon-arrow-up-right-2" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="landing-footer__bottom row align-items-center gy-2">
            <div className="landing-footer__lang col-md-3">
              <LanguageDropdown instanceId="langDropdownLanding" />
            </div>
            <div className="landing-footer__copy col-md-5">
              <span>{LanguageConstants?.COPYRIGHT}</span>
            </div>
            <div className="landing-footer__legal col-md-4">
              <Link to="/cms/privacy-policy">{LanguageConstants?.PRIACYPOLICY}</Link>
              <Link to="/cms/terms-and-conditions">{LanguageConstants?.TERMS}</Link>
            </div>
          </div>
        </div>
      </footer>

    </>
  )
}

export default Footer